import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef(function TabsList(
  { className = "", ...props },
  ref
) {
  return (
    <TabsPrimitive.List
      ref={ref}
      className={className}
      {...props}
    />
  );
});

export const TabsTrigger = React.forwardRef(function TabsTrigger(
  { className = "", ...props },
  ref
) {
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={className}
      {...props}
    />
  );
});

export const TabsContent = React.forwardRef(function TabsContent(
  { className = "", ...props },
  ref
) {
  return (
    <TabsPrimitive.Content
      ref={ref}
      className={className}
      {...props}
    />
  );
});
